import React, { useState } from 'react'
import { Button, Modal, notification } from 'antd'
import { useSelector } from 'react-redux'
import { getRoster, moveToReserve } from '../../../redux/actions/rosterAction'
import { reservedPlayer } from '../../../config/constants'

const MoveToReserve = ({ disabled, playerId, reservedPlayers: rpLength, pInterfaceModalClose }) => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const showModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  const _moveToReserve = async () => {
    if (rpLength < reservedPlayer) {
      setLoading(true)
      const res = await moveToReserve({
        id: playerId,
        date: SETTING?.date,
      })
      if (res) {
        closeModal()
        pInterfaceModalClose()
        await getRoster(SETTING?.date)
      }
      setLoading(false)
    } else {
      notification.error({
        message: `Your reserved player is full`,
        duration: 3,
      })
    }
  }

  return (
    <>
      <Button disabled={disabled} type='primary' className='action-bar-btn' onClick={showModal}>
        Reserve Player
      </Button>
      <Modal
        centered
        open={open}
        onCancel={closeModal}
        footer={null}
        closeIcon={false}
        className='player_interface_modals'
        closable={false}
      >
        <div className='close_modal_button' onClick={closeModal}>
          x
        </div>
        <div className='modal_body'>
          <h1 className='modal_header_heading main_heading'>Reserve Player</h1>

          <div className='center_content move_to_injured'>
            <h1 className='modal_header_heading'>ARE YOU SURE?</h1>
            {/* <p style={{ textTransform: 'uppercase' }}>
              {`To place this player on the Injured Reserve, click the "Move to I.R." button if you're sure.`}
            </p> */}
            {/* <p style={{ textTransform: 'uppercase' }}>
              {`info: This action will lead to the player's Cap Hit being excluded from your team's overall total until the player is reinstated to your active roster.`}
            </p> */}
          </div>

          <div className='modal_footer'>
            <Button loading={loading} type='primary' className='button_1' onClick={_moveToReserve}>
              Reserve Player
            </Button>
            <Button onClick={closeModal} type='primary' className='button_2'>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default MoveToReserve
